import React from 'react';
import { HeroSection } from './HeroSection';
import { PainPointSection } from './PainPointSection';
import { SolutionSection } from './SolutionSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { PurchasePopup } from './PurchasePopup';
export function SalesPage() {
  return <div className="min-h-screen font-body bg-cream selection:bg-gold-400 selection:text-white" data-id="element-153">
      <PurchasePopup data-id="element-154" />
      <main data-id="element-155">
        <HeroSection data-id="element-156" />
        <PainPointSection data-id="element-157" />
        <SolutionSection data-id="element-158" />
        <BeforeAfterSection data-id="element-159" />
        <BonusSection data-id="element-160" />
        <PricingSection data-id="element-161" />
        <TestimonialsSection data-id="element-162" />
        <FAQSection data-id="element-163" />
        <FinalCTA data-id="element-164" />
      </main>
      <footer className="bg-brown-800 text-white/60 py-8 text-center text-sm" data-id="element-165">
        <p data-id="element-166">
          © {new Date().getFullYear()} Freezer Inteligente. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-167">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}